export default "__VITE_ASSET__DejMd0LF__"